import { useState, useCallback, useRef } from 'react'

function useForm(fields) {
    const [model, setModel] = useState(processModel(fields, e => change(e), (name, value) => setValue(name, value)))
    const data = useRef(processData(model))
    const change = useCallback(e => {
        const {name, value, type, checked} = e.target
        setModel(model => {
            model[name].value = type === 'checkbox' ? checked : value
            data.current = processData(model)
            return {
                ...model
            }
        })
    }, [])

    const setValue = useCallback((name, value) => {
        setModel(model => {
            model[name].value = value
            data.current = processData(model)
            return {
                ...model
            }
        })
    }, [])


    return [model, data.current]
} 

function processModel(fields, change, setValue) {
    const data = {}
    Object.keys(fields).map(k => {
        let v = fields[k]
        data[k] = {
            onChange: e => change(e),
            value: v,
            name: k,
            setValue: value => {
                setValue(k, value)
            },
            ref: useRef(null),
        }
    })
    return data 
}

function processData(model) {
    let values = {}
    Object.keys(model).map(field => {
        values[field] = model[field].value
    })

    return values
}

export default useForm


// WEBPACK FOOTER //
// ./src/SPRINTA/v3/Form/useForm.js